import { css } from "@emotion/react";
import { Colors, Link, Text } from "@zapier/design-system";

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    padding: var(--zds-space-20);
    background-color: ${Colors.BrandCream};
  `,
  textContainer: css`
    text-align: center;
    max-width: 480px;
  `,
};

export function AppErrorScreen() {
  return (
    <div css={styles.container}>
      <div css={styles.textContainer}>
        <Text tag="h1" type="PageHeader">
          Oh no!
        </Text>
        <Text tag="p" type="Body1">
          Looks like we&apos;ve run into an issue. Refresh the page or go to{" "}
          <Link href="/app/get-help">Get Help</Link> instead.
        </Text>
      </div>
    </div>
  );
}
